export const abdominal = (() => {
    const placeHolderText = 'Soft, nontender no masses'

    return placeHolderText
})